import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import faqConf from '@/common/store/glb/data.faqs';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import { mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import { parseQueryString } from '@/common/utilities/nojq/_utilities.js';
import { loadInsurancePop } from '@/common/utilities/nojq/_load.ojolink.js';

export default {
    name: 'pageInsurance',
    inject: ['$eventBus'],
    components: {
        mvtDialogCenter,
        mvtInputGeo,
        mvtArticle,
        mvtFaq,
        mortgageTools,
        mvtWelcome,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
    },
    data() {
        return {
            geoInfo: {
                text: '',
                geo: null,
            },
            zipcode: '',
            tag: null,
            faqQuery: null,
        };
    },
    watch: {
        geoInfo(newVal) {
            if (newVal && newVal.geo) {
                this.$eventBus.$emit('eventbus-pop-insurance', {
                    text: newVal.text,
                    geo: newVal.geo,
                    trigger: 'getquotes_insurancepage',
                });
            }
        },
    },
    mounted() {
        this.tag = this.glb.articleConfig.tag.preApproval + '';
        this.faqQuery = faqConf.preapproval;
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
    beforeUnmount() {
        var winOpt = {};
        if (window && window.location && window.location.search) {
            winOpt = parseQueryString(window.location.search);
        }
        if (winOpt.zipcode && winOpt.address && winOpt.state && winOpt.city) {
            loadInsurancePop(winOpt.address, winOpt.zipcode, winOpt.state, winOpt.city);
        }
    },
};
